import { render, staticRenderFns } from "./buy-notice.vue?vue&type=template&id=4e135c7b&scoped=true&"
import script from "./buy-notice.vue?vue&type=script&lang=js&"
export * from "./buy-notice.vue?vue&type=script&lang=js&"
import style0 from "./buy-notice.vue?vue&type=style&index=0&id=4e135c7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e135c7b",
  null
  
)

export default component.exports